module.exports = __webpack_public_path__ + "img/money-outlined-grey.b1708387.svg";